import { render, staticRenderFns } from "./ExchangeRates.vue?vue&type=template&id=979d1520&scoped=true&"
import script from "./ExchangeRates.vue?vue&type=script&lang=js&"
export * from "./ExchangeRates.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeRates.vue?vue&type=style&index=0&id=979d1520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979d1520",
  null
  
)

export default component.exports